<!-- <button class="btn btn-primary pull-right"><i class="fa fa-fa-window-close"></i></button> -->
<div [class.loader-hidden]="!show" id="loader-wrapper" class="centerDiv">
    <div id="loader-spin">
        <!-- <img src="assets/images/loaderAjax.gif"> -->
    </div>
</div>